import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { APP_STORE_URL } from "@/constants";

export const StickyMobileCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#070C18]/92 px-4 py-3 backdrop-blur-xl transition-[transform,opacity] duration-300 md:hidden ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-full opacity-0"
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-1.5 text-sm text-slate-300">
          <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
          <span className="font-semibold text-white">5.0</span>
          <span className="text-slate-400">on the App Store</span>
        </div>
        <a
          data-testid="sticky-appstore-button"
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-slate-950 active:scale-[0.97] transition-transform duration-150"
        >
          Download Free
        </a>
      </div>
    </div>
  );
};
